import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.reducers';
import { HttpClient } from "@angular/common/http";
import { SigninGeneralService } from '../../shared/signinGeneral.service';
import { AlertService } from "../../shared/alert/alert.service";

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.scss'],
  standalone: false
})

export class PasswordChangeComponent implements OnInit , OnDestroy {
  email: string = null;
  uid: string = null;
  hasError = false;
  title = '';
  inOperation = false;
  error = '';
  user_subscription: Subscription;
  currentField = '';
  constructor(private store: Store<AppState>, private httpClient: HttpClient,
              public generalService: SigninGeneralService, public alertService: AlertService) { }
  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: Event) {
    this.currentField = event.target['id'];
  }

  ngOnInit() {
    this.user_subscription = this.store.select('auth').subscribe({
      next:
        (authState) => {
          if (authState!==null && authState.user!==null) {
            this.email = authState.user.email;
            this.uid = authState.user.id;
            this.title = authState.msg;
          }
        }
    });
  }

  onReset(newPassword: string) {
    if (newPassword === '') {
      this.generalService.back_to_login(0, false);
      return;
    }
    this.inOperation = true;
    this.httpClient.post<string[]>('aauth/update_user',{
      email: this.email,
      uid: this.uid,
      password: newPassword
    }).subscribe({next: (ans: any) => {
        if (ans['ok']) {
          this.alertService.popupOKOnly('Message', 'Your Password was changed successfully.',
            'You will be redirected to the ViewersLogic Platform shortly...');
          this.generalService.back_to_login(3000, true);
        } else {
          this.alertService.popupOKOnly('Error', 'Your Password was not changed.', ans['error']);
          this.generalService.back_to_login(1000, false);
        }
      }});
  }

  ngOnDestroy() {
    this.httpClient.post<string[]>('aauth/delete_cookies',{}).subscribe();
  }
}

